import { useSettings } from '../useSettings'

/**
 * IMPORTANT! Use inside mobx-react-lite observer!!!
 */
export const useTimezone = () => {
  const { settings } = useSettings()
  return settings?.timeZone
}
